module.exports = __webpack_public_path__ + "static/media/min-contour-icon.ac48cca0.svg";